module.exports = __webpack_public_path__ + "static/footer-bg-mobile-8b2d0b6f2942ddee3d1ccd99bcc5375f.jpg";